module.exports = __webpack_public_path__ + "img/certificate01-1.919cc23d.jpg";